import { computed } from "vue";
import { i18n } from "./../../i18n";
const { t } = i18n.global;

const menuItems = computed(() => [
    {
        slug: "start-page",
        path: "/start-page",
        name: "StartPage",
        label: t("ruleshub.pages.menuItems.startPage.linkLabel"),
    },
    {
        slug: "validation-engine-test",
        path: "/validation-engine-test",
        name: "ValidationEngineTestPage",
        label: t("ruleshub.pages.menuItems.validationEngineTestPage.linkLabel"),
    },
]);

export { menuItems };
